import { fmtDateTime } from '../utils/date';
import React, { useEffect, useState } from 'react';
import { api } from '../api/client';
import MassSmsCard from '../components/MassSmsCard';
const errText = (e: any, fb: string) => { try { return JSON.parse(e?.message).detail || fb; } catch { return e?.message || fb; } };


const ACTION_LABELS: Record<string, string> = {
  login: 'Нэвтрэх',
  change_password: 'Нууц үг солих',
  update_profile: 'Профайл засах',
  update_settings: 'Тохиргоо шинэчлэх',
  create_admin_user: 'Хэрэглэгч нэмэх',
  update_admin_user: 'Хэрэглэгч засах',
  create_tenant: 'СӨХ нэмэх',
  update_plan: 'Төлөвлөгөө солих',
  create_invoice: 'Нэхэмжлэх үүсгэх',
  create_payment: 'Төлбөр бүртгэх',
  create_poll: 'Санал асуулга үүсгэх',
  announce: 'Зарлал илгээх',
};

export default function SettingsPage() {
  const [me, setMe] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('profile');
  const [pwForm, setPwForm] = useState({ current: '', new_password: '', confirm: '' });
  const [pwMsg, setPwMsg] = useState('');
  const [pwErr, setPwErr] = useState('');
  const [profileForm, setProfileForm] = useState({ first_name: '', last_name: '' });
  const [profileMsg, setProfileMsg] = useState('');
  const [tenantSettings, setTenantSettings] = useState<any>(null);
  const [settingsForm, setSettingsForm] = useState<any>({});
  const [bankForm, setBankForm] = useState<any>({ bank_name: '', bank_account_number: '', bank_account_name: '', bpay_biller_code: '' });
  const [bankMsg, setBankMsg] = useState('');
  const [billerMsg, setBillerMsg] = useState('');
  const [billerBusy, setBillerBusy] = useState(false);
  const [qpayStatus, setQpayStatus] = useState<any>(null);
  const [vendorCfg, setVendorCfg] = useState<any>(null);
  const [vendorForm, setVendorForm] = useState<any>({ url: '', username: '', password: '', terminal_id: '' });
  const [vendorMsg, setVendorMsg] = useState('');
  const [vendorBusy, setVendorBusy] = useState(false);
  const [backupBusy, setBackupBusy] = useState(false);
  const [backupStatus, setBackupStatus] = useState<any>(null);
  const [backupMsg, setBackupMsg] = useState('');

  const loadBackupStatus = () => {
    api.get('/admin/platform/backup/status').then(setBackupStatus).catch(() => {});
  };
  const runBackup = async () => {
    if (!window.confirm('Одоо өгөгдлийн сангийн нөөц хийх үү? (R2-д хадгалж, имэйлээр илгээнэ)')) return;
    setBackupBusy(true); setBackupMsg('');
    try {
      const res: any = await api.post('/admin/platform/backup/run', {});
      setBackupMsg(`✅ Нөөц хийгдлээ: ${res.filename} (${res.size_mb} MB)${res.emailed ? ' · имэйлдсэн' : ''}`);
      loadBackupStatus();
    } catch (e: any) {
      setBackupMsg('Алдаа: ' + (e?.body ? JSON.parse(e.body)?.detail || e.message : e.message));
    } finally { setBackupBusy(false); }
  };
  // Платформ админ: СӨХ сонгож данс засах
  const [paTenants, setPaTenants] = useState<any[]>([]);
  const [paTenantId, setPaTenantId] = useState('');
  const [paBank, setPaBank] = useState<any>(null);
  const [paStatus, setPaStatus] = useState<any>(null);
  const [paMsg, setPaMsg] = useState('');
  const [paBusy, setPaBusy] = useState(false);
  const [qpayMsg, setQpayMsg] = useState('');
  const [qpayBusy, setQpayBusy] = useState(false);
  const [settingsMsg, setSettingsMsg] = useState('');
  const [auditLogs, setAuditLogs] = useState<any[]>([]);
  const [auditTotal, setAuditTotal] = useState(0);
  const [auditLoading, setAuditLoading] = useState(false);
  const [emailStatus, setEmailStatus] = useState<any>(null);
  const [testEmail, setTestEmail] = useState('');
  const [testResult, setTestResult] = useState<{ success: boolean; error?: string } | null>(null);
  const [testSending, setTestSending] = useState(false);

  useEffect(() => {
    api.get('/admin/me').then(data => {
      setMe(data);
      setProfileForm({ first_name: data?.first_name || '', last_name: data?.last_name || '' });
    }).catch(() => {}).finally(() => setLoading(false));

    api.get('/admin/settings').then(data => {
      setTenantSettings(data);
      setSettingsForm({
        contact_phone: data?.contact_phone || '',
        contact_email: data?.contact_email || '',
        address: data?.address || '',
        facebook_url: data?.facebook_url || '',
        show_expenses_public: data?.show_expenses_public !== false,
        payment_due_day: data?.payment_due_day || 25,
        billing_collect_day: data?.billing_collect_day || 1,
        late_fee_enabled: data?.late_fee_enabled || false,
        late_fee_percent: data?.late_fee_percent || 0,
        late_fee_start_days: data?.late_fee_start_days || 30,
        quiet_hours_start: data?.quiet_hours_start || 22,
        quiet_hours_end: data?.quiet_hours_end || 8,
      });
    }).catch(() => {});

    api.get('/admin/settings/bank-info').then(data => {
      setBankForm({
        bank_name: data?.bank_name || '',
        bank_account_number: data?.bank_account_number || '',
        bank_account_name: data?.bank_account_name || '',
        bpay_biller_code: data?.bpay_biller_code || '',
        qpay_username: data?.qpay_username || '',
        qpay_invoice_code: data?.qpay_invoice_code || '',
        qpay_password: '',                                  // нууц үг хэзээ ч буцаж ирэхгүй
        qpay_password_set: !!data?.qpay_password_set,
        garage_bank_name: data?.garage_bank_name || '', garage_bank_account_number: data?.garage_bank_account_number || '', garage_bank_account_name: data?.garage_bank_account_name || '',
      });
    }).catch(() => {});

    api.get('/admin/qpay/vendor-status').then(setQpayStatus).catch(() => {});
  }, []);

  const loadAuditLogs = () => {
    setAuditLoading(true);
    api.get('/admin/audit-logs?limit=50')
      .then(data => { setAuditLogs(data?.items || []); setAuditTotal(data?.total || 0); })
      .catch(() => {})
      .finally(() => setAuditLoading(false));
  };

  useEffect(() => {
    if (activeTab === 'audit') loadAuditLogs();
    if (activeTab === 'email') {
      api.get('/admin/settings/email-status').then(setEmailStatus).catch(() => {});
    }
    if (activeTab === 'platform') {
      api.get('/platform/qpay-vendor').then((d: any) => {
        setVendorCfg(d);
        setVendorForm({ url: d?.url || '', username: d?.username || '', password: '', terminal_id: d?.terminal_id || '' });
      }).catch(() => {});
      api.get('/admin/users/tenants').then((r: any) => setPaTenants(r?.items || [])).catch(() => {});
      loadBackupStatus();
    }
  }, [activeTab]);

  const handleTestEmail = async () => {
    if (!testEmail) return;
    setTestSending(true);
    setTestResult(null);
    try {
      const res = await api.post('/admin/settings/test-email', { to_email: testEmail });
      setTestResult(res);
    } catch {
      setTestResult({ success: false, error: 'Алдаа гарлаа' });
    }
    setTestSending(false);
  };

  const handlePwChange = async (e: React.FormEvent) => {
    e.preventDefault();
    setPwMsg(''); setPwErr('');
    if (pwForm.new_password !== pwForm.confirm) {
      setPwErr('Нууц үг тохирохгүй байна');
      return;
    }
    if (pwForm.new_password.length < 6) {
      setPwErr('Нууц үг хамгийн багадаа 6 тэмдэгт');
      return;
    }
    try {
      await api.put('/admin/me/password', {
        current_password: pwForm.current,
        new_password: pwForm.new_password,
      });
      setPwMsg('Нууц үг амжилттай солигдлоо');
      setPwForm({ current: '', new_password: '', confirm: '' });
    } catch (err: any) {
      setPwErr(err?.response?.data?.detail || 'Алдаа гарлаа');
    }
  };

  const handleProfileUpdate = async () => {
    try {
      const data = await api.put('/admin/me/profile', profileForm);
      setMe({ ...me, ...data });
      setProfileMsg('Профайл шинэчлэгдлээ');
      setTimeout(() => setProfileMsg(''), 3000);
    } catch {
      setProfileMsg('Алдаа гарлаа');
    }
  };

  const handleSettingsSave = async () => {
    try {
      await api.put('/admin/settings', settingsForm);
      setSettingsMsg('Тохиргоо хадгалагдлаа');
      setTimeout(() => setSettingsMsg(''), 3000);
    } catch {
      setSettingsMsg('Алдаа гарлаа');
    }
  };

  const handleBankSave = async () => {
    try {
      const res = await api.put('/admin/settings/bank-info', bankForm);
      // Нууц үгийг формоос арилгана — сервер буцаадаггүй, дахин илгээх ч шаардлагагүй.
      setBankForm((f: any) => ({ ...f, qpay_password: '', qpay_password_set: !!res?.qpay_password_set }));
      loadQpayStatus();
      setBankMsg('Банкны данс хадгалагдлаа');
      setTimeout(() => setBankMsg(''), 3000);
    } catch {
      setBankMsg('Алдаа гарлаа');
    }
  };

  const loadQpayStatus = () => {
    api.get('/admin/qpay/vendor-status').then(setQpayStatus).catch(() => {});
  };

  const handleQpayRegister = async () => {
    setQpayBusy(true);
    try {
      const res = await api.post('/admin/qpay/register-merchant', {});
      setQpayMsg(res?.message || 'QPay-д бүртгэгдлээ');
      loadQpayStatus();
      setTimeout(() => setQpayMsg(''), 5000);
    } catch (e: any) {
      const detail = e?.body ? JSON.parse(e.body)?.detail : null;
      setQpayMsg(`Алдаа: ${detail || 'бүртгэж чадсангүй'}`);
    } finally {
      setQpayBusy(false);
    }
  };

  const loadPaTenant = (tid: string) => {
    setPaTenantId(tid);
    setPaBank(null); setPaStatus(null); setPaMsg('');
    if (!tid) return;
    api.get(`/admin/settings/bank-info?tenant_id=${tid}`).then((d: any) => setPaBank({
      bank_name: d?.bank_name || '', bank_account_number: d?.bank_account_number || '',
      bank_account_name: d?.bank_account_name || '', bpay_biller_code: d?.bpay_biller_code || '',
      qpay_username: d?.qpay_username || '', qpay_invoice_code: d?.qpay_invoice_code || '',
      qpay_password: '', qpay_password_set: !!d?.qpay_password_set,
      garage_bank_name: d?.garage_bank_name || '', garage_bank_account_number: d?.garage_bank_account_number || '', garage_bank_account_name: d?.garage_bank_account_name || '',
    })).catch(() => setPaMsg('Алдаа: данс уншиж чадсангүй'));
    api.get(`/admin/qpay/vendor-status?tenant_id=${tid}`).then(setPaStatus).catch(() => {});
  };

  const handlePaBankSave = async () => {
    if (!paTenantId || !paBank) return;
    setPaBusy(true);
    try {
      const res = await api.put('/admin/settings/bank-info', { ...paBank, tenant_id: paTenantId });
      setPaBank((f: any) => ({ ...f, qpay_password: '', qpay_password_set: !!res?.qpay_password_set }));
      setPaMsg('Данс хадгалагдлаа');
      api.get(`/admin/qpay/vendor-status?tenant_id=${paTenantId}`).then(setPaStatus).catch(() => {});
      setTimeout(() => setPaMsg(''), 4000);
    } catch (e: any) {
      setPaMsg(`Алдаа: ${e?.body ? JSON.parse(e.body)?.detail : 'хадгалж чадсангүй'}`);
    } finally { setPaBusy(false); }
  };

  const handlePaQpayRegister = async (force = false) => {
    if (!paTenantId) return;
    if (force && !window.confirm('Хуучин merchant-ыг цэвэрлэж, одоогийн орчинд ДАХИН бүртгэх үү?\n(Sandbox → production шилжсэн үед хэрэглэнэ)')) return;
    setPaBusy(true);
    try {
      const res = await api.post('/admin/qpay/register-merchant', { tenant_id: paTenantId, force });
      setPaMsg(res?.message || 'QPay-д бүртгэгдлээ');
      api.get(`/admin/qpay/vendor-status?tenant_id=${paTenantId}`).then(setPaStatus).catch(() => {});
      setTimeout(() => setPaMsg(''), 5000);
    } catch (e: any) {
      setPaMsg(`Алдаа: ${e?.body ? JSON.parse(e.body)?.detail : 'бүртгэж чадсангүй'}`);
    } finally { setPaBusy(false); }
  };

  const handleVendorSave = async () => {
    setVendorBusy(true);
    try {
      const res = await api.put('/platform/qpay-vendor', vendorForm);
      setVendorCfg(res);
      setVendorForm((f: any) => ({ ...f, password: '' }));
      setVendorMsg(res?.message || 'Хадгалагдлаа');
      setTimeout(() => setVendorMsg(''), 5000);
    } catch (e: any) {
      setVendorMsg(`Алдаа: ${e?.body ? JSON.parse(e.body)?.detail : 'хадгалж чадсангүй'}`);
    } finally { setVendorBusy(false); }
  };

  const handleVendorTest = async () => {
    setVendorBusy(true);
    try {
      await api.post('/platform/qpay-vendor/test', {});
      setVendorMsg('✅ QPay-тэй амжилттай холбогдлоо');
    } catch (e: any) {
      setVendorMsg(`Алдаа: ${e?.body ? JSON.parse(e.body)?.detail : 'холбогдож чадсангүй'}`);
    } finally { setVendorBusy(false); }
  };

  const handleBackfillCodes = async () => {
    setBillerBusy(true);
    try {
      const res = await api.post('/admin/bpay/customer-codes/backfill', {});
      const n = res?.assigned ?? 0;
      setBillerMsg(n > 0 ? `${n} айлд шинэ код олгогдлоо` : 'Бүх айл аль хэдийн кодтой байна');
      setTimeout(() => setBillerMsg(''), 4000);
    } catch {
      setBillerMsg('Алдаа гарлаа');
    } finally {
      setBillerBusy(false);
    }
  };

  const roleLabel: Record<string, string> = {
    manager: 'Менежер', director: 'Захирал', guard: 'Харуул', platform_admin: 'Платформ админ',
  };

  const PLAN_LABELS: Record<string, string> = {
    basic: 'Basic', standard: 'Standard', pro: 'Pro', enterprise: 'Enterprise',
  };

  const STATUS_LABELS: Record<string, string> = {
    trial: 'Туршилт', active: 'Идэвхтэй', read_only: 'Зөвхөн уншигдана', suspended: 'Түр зогсоосон', offboarded: 'Цуцлагдсан',
  };

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#5f6f66' }}>Ачаалж байна...</div>;

  const isPlatformAdmin = me?.role === 'platform_admin';
  const tabs = [
    { key: 'profile', label: 'Профайл' },
    { key: 'tenant', label: 'СӨХ тохиргоо' },
    { key: 'billing', label: 'Төлбөр' },
    { key: 'facebook', label: 'Facebook холболт' },
    { key: 'intercom', label: 'Домофон' },
    { key: 'email', label: 'Имэйл' },
    { key: 'audit', label: 'Үйл ажиллагааны лог' },
    ...(isPlatformAdmin ? [{ key: 'platform', label: 'Платформ' }] : []),
  ];

  return (
    <div>
      <h1 style={{ fontFamily: "'Inter'", fontSize: 24, fontWeight: 700, color: '#1c2b22', margin: '0 0 24px' }}>
        Тохиргоо
      </h1>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 24, borderBottom: '2px solid #e8e5dc', paddingBottom: 0 }}>
        {tabs.map(t => (
          <button key={t.key} onClick={() => setActiveTab(t.key)} style={{
            padding: '10px 20px', border: 'none', cursor: 'pointer', fontSize: 14, fontWeight: activeTab === t.key ? 600 : 400,
            color: activeTab === t.key ? '#236844' : '#5f6f66',
            background: 'transparent',
            borderBottom: activeTab === t.key ? '2px solid #236844' : '2px solid transparent',
            marginBottom: -2,
          }}>
            {t.label}
          </button>
        ))}
      </div>

      {/* Profile Tab */}
      {activeTab === 'profile' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
          <div style={card}>
            <h3 style={cardTitle}>Миний мэдээлэл</h3>
            {me && (
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20 }}>
                  <div style={{
                    width: 56, height: 56, borderRadius: 14,
                    background: 'linear-gradient(135deg, #2f7d52, #236844)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#fff', fontFamily: "'Inter'", fontWeight: 700, fontSize: 22,
                  }}>
                    {(me.first_name || 'A')[0]}
                  </div>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 16, color: '#1c2b22' }}>{me.first_name} {me.last_name}</div>
                    <div style={{ color: '#5f6f66', fontSize: 14 }}>{me.email}</div>
                  </div>
                </div>
                {profileMsg && <div style={{ ...msgStyle, background: profileMsg.includes('Алдаа') ? '#fee2e2' : '#f0fdf4', color: profileMsg.includes('Алдаа') ? '#dc2626' : '#166534' }}>{profileMsg}</div>}
                <div style={{ display: 'grid', gap: 12, marginBottom: 16 }}>
                  <div>
                    <label style={labelStyle}>Нэр</label>
                    <input value={profileForm.first_name} onChange={e => setProfileForm({ ...profileForm, first_name: e.target.value })} style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>Овог</label>
                    <input value={profileForm.last_name} onChange={e => setProfileForm({ ...profileForm, last_name: e.target.value })} style={inputStyle} />
                  </div>
                </div>
                <div style={{ display: 'grid', gap: 12, marginBottom: 16 }}>
                  <InfoRow label="Эрх" value={roleLabel[me.role] || me.role} />
                  <InfoRow label="Төлөв" value={me.is_active ? 'Идэвхтэй' : 'Идэвхгүй'} />
                </div>
                <button onClick={handleProfileUpdate} style={btnPrimary}>Хадгалах</button>
              </div>
            )}
          </div>

          <div style={card}>
            <h3 style={cardTitle}>Идэвхтэй сесс</h3>
            <p style={{ margin: '0 0 12px', fontSize: 13, color: '#5f6f66' }}>Бүх төхөөрөмж (утас, компьютер) дээрх нэвтрэлтийг нэг дор цэвэрлэнэ. Дараа нь дахин нэвтэрнэ.</p>
            <button onClick={async () => { if (!window.confirm('Бүх төхөөрөмжөөс гарах уу? Одоогийн сесс ч хаагдана.')) return; try { await api.post('/auth/admin/me/logout-all'); } catch {} localStorage.removeItem('admin_token'); localStorage.removeItem('admin_refresh_token'); localStorage.removeItem('admin_user'); window.location.href = '/login'; }} style={{ ...btnPrimary, background: '#fff', color: '#dc2626', border: '1px solid #fecaca' }}>Бүх төхөөрөмжөөс гарах</button>
          </div>

          <div style={card}>
            <h3 style={cardTitle}>Нууц үг солих</h3>
            {pwMsg && <div style={{ ...msgStyle, background: '#f0fdf4', color: '#166534' }}>{pwMsg}</div>}
            {pwErr && <div style={{ ...msgStyle, background: '#fee2e2', color: '#dc2626' }}>{pwErr}</div>}
            <form onSubmit={handlePwChange}>
              <div style={{ marginBottom: 14 }}>
                <label style={labelStyle}>Одоогийн нууц үг</label>
                <input type="password" value={pwForm.current} onChange={e => setPwForm({ ...pwForm, current: e.target.value })} style={inputStyle} required />
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={labelStyle}>Шинэ нууц үг</label>
                <input type="password" value={pwForm.new_password} onChange={e => setPwForm({ ...pwForm, new_password: e.target.value })} style={inputStyle} required />
              </div>
              <div style={{ marginBottom: 18 }}>
                <label style={labelStyle}>Нууц үг давтах</label>
                <input type="password" value={pwForm.confirm} onChange={e => setPwForm({ ...pwForm, confirm: e.target.value })} style={inputStyle} required />
              </div>
              <button type="submit" style={btnPrimary}>Нууц үг солих</button>
            </form>
          </div>
        </div>
      )}

      {/* Tenant Settings Tab */}
      {activeTab === 'tenant' && tenantSettings && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
          <DistrictCard card={card} cardTitle={cardTitle} inputStyle={inputStyle} btnPrimary={btnPrimary} msgStyle={msgStyle} initial={{ district: tenantSettings.district || '', khoroo: tenantSettings.khoroo || '', logo: tenantSettings.district_logo_url || '' }} />
          <div style={card}>
            <h3 style={cardTitle}>СӨХ мэдээлэл</h3>
            <div style={{ display: 'grid', gap: 12, marginBottom: 20 }}>
              <InfoRow label="Нэр" value={tenantSettings.name} />
              <InfoRow label="Бүртгэлийн дугаар" value={tenantSettings.registration_number} />
              <InfoRow label="Төлөвлөгөө" value={PLAN_LABELS[tenantSettings.plan] || tenantSettings.plan} />
              <InfoRow label="Төлөв" value={STATUS_LABELS[tenantSettings.status] || tenantSettings.status} />
              <InfoRow label="Хамгийн их орон сууц" value={String(tenantSettings.max_units)} />
            </div>
          </div>

          <div style={card}>
            <h3 style={cardTitle}>Холбоо барих мэдээлэл</h3>
            {settingsMsg && <div style={{ ...msgStyle, background: settingsMsg.includes('Алдаа') ? '#fee2e2' : '#f0fdf4', color: settingsMsg.includes('Алдаа') ? '#dc2626' : '#166534' }}>{settingsMsg}</div>}
            <div style={{ display: 'grid', gap: 14 }}>
              <div>
                <label style={labelStyle}>Утасны дугаар</label>
                <input value={settingsForm.contact_phone} onChange={e => setSettingsForm({ ...settingsForm, contact_phone: e.target.value })} style={inputStyle} placeholder="7000-1234" />
              </div>
              <div>
                <label style={labelStyle}>Имэйл</label>
                <input value={settingsForm.contact_email} onChange={e => setSettingsForm({ ...settingsForm, contact_email: e.target.value })} style={inputStyle} placeholder="info@narny.mn" />
              </div>
              <div>
                <label style={labelStyle}>Хаяг</label>
                <textarea value={settingsForm.address} onChange={e => setSettingsForm({ ...settingsForm, address: e.target.value })} style={{ ...inputStyle, minHeight: 60, resize: 'vertical' }} placeholder="СӨХ-ийн хаяг" />
              </div>
              <div>
                <label style={labelStyle}>Facebook групп линк</label>
                <input value={settingsForm.facebook_url} onChange={e => setSettingsForm({ ...settingsForm, facebook_url: e.target.value })} style={inputStyle} placeholder="https://www.facebook.com/groups/..." />
              </div>
              <div>
                <label style={labelStyle}>Зардлын нэгтгэл оршин суугчдад</label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, minHeight: 40, fontSize: 14, cursor: 'pointer' }}>
                  <input type="checkbox" checked={settingsForm.show_expenses_public !== false} onChange={e => setSettingsForm({ ...settingsForm, show_expenses_public: e.target.checked })} />
                  QR → Тайлан → «Зардал» хэсэгт сарын зардлыг төрлөөр харуулах (баримтын зураг харагдахгүй)
                </label>
              </div>
              <div>
                <label style={labelStyle}>Чимээгүй цаг (эхлэх)</label>
                <select value={settingsForm.quiet_hours_start} onChange={e => setSettingsForm({ ...settingsForm, quiet_hours_start: Number(e.target.value) })} style={inputStyle}>
                  {Array.from({ length: 24 }, (_, i) => <option key={i} value={i}>{String(i).padStart(2, '0')}:00</option>)}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Чимээгүй цаг (дуусах)</label>
                <select value={settingsForm.quiet_hours_end} onChange={e => setSettingsForm({ ...settingsForm, quiet_hours_end: Number(e.target.value) })} style={inputStyle}>
                  {Array.from({ length: 24 }, (_, i) => <option key={i} value={i}>{String(i).padStart(2, '0')}:00</option>)}
                </select>
              </div>
            </div>
            <button onClick={handleSettingsSave} style={{ ...btnPrimary, marginTop: 16 }}>Хадгалах</button>
          </div>

          {/* Банкны данс — төлбөр хүлээн авах */}
          <div style={{ ...card, marginTop: 16 }}>
            <h3 style={{ margin: '0 0 4px', fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22' }}>Банкны данс</h3>
            <p style={{ margin: '0 0 16px', fontSize: 13, color: '#5f6f66' }}>
              Оршин суугчдын төлбөр хүлээн авах СӨХ-ийн банкны данс. QPay/BPay төлбөр энэ данс руу шилжинэ.
            </p>
            {!isPlatformAdmin && (
              <div style={{ background: '#eff6ff', color: '#1d4ed8', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 14 }}>
                🔒 Дансны мэдээллийг зөвхөн платформын админ бүртгэж, заsдаг. Өөрчлөлт хийлгэх бол
                платформын админд хандана уу.
              </div>
            )}
            {bankMsg && <div style={{ ...msgStyle, background: bankMsg.includes('Алдаа') ? '#fee2e2' : '#f0fdf4', color: bankMsg.includes('Алдаа') ? '#dc2626' : '#166534' }}>{bankMsg}</div>}
            <fieldset disabled={!isPlatformAdmin} style={{ border: 'none', padding: 0, margin: 0 }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div>
                <label style={labelStyle}>Банк</label>
                <select value={bankForm.bank_name} onChange={e => setBankForm({ ...bankForm, bank_name: e.target.value })} style={inputStyle}>
                  <option value="">-- Сонгох --</option>
                  {['Төрийн банк', 'Хаан банк', 'Голомт банк', 'Худалдаа хөгжлийн банк', 'Хас банк', 'Капитрон банк', 'Ариг банк', 'Богд банк', 'Тээвэр хөгжлийн банк', 'Үндэсний хөрөнгө оруулалтын банк'].map(b => <option key={b} value={b}>{b}</option>)}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Дансны дугаар (IBAN)</label>
                <input value={bankForm.bank_account_number} onChange={e => setBankForm({ ...bankForm, bank_account_number: e.target.value })} style={inputStyle} placeholder="MN350034102220131496" />
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={labelStyle}>Данс эзэмшигчийн нэр</label>
                <input value={bankForm.bank_account_name} onChange={e => setBankForm({ ...bankForm, bank_account_name: e.target.value })} style={inputStyle} placeholder="Нарны хороолол СӨХ" />
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={labelStyle}>BPay biller код</label>
                <input value={bankForm.bpay_biller_code || ''} onChange={e => setBankForm({ ...bankForm, bpay_biller_code: e.target.value })} style={inputStyle} placeholder="BPay-д biller болгож бүртгүүлэхэд олгосон код" />
                <p style={{ margin: '4px 0 0', fontSize: 12, color: '#8a978f' }}>СӨХ-ийн дансыг BPay-д biller болгож бүртгүүлсний дараа BPay-аас олгосон кодыг энд оруулна.</p>
              </div>

              <div style={{ gridColumn: '1 / -1', borderTop: '1px solid #e8e5dc', paddingTop: 16, marginTop: 4 }}>
                <h4 style={{ margin: '0 0 4px', fontWeight: 700, color: '#1c2b22', fontSize: 15 }}>Гражийн төлбөр хүлээн авах данс <span style={{ fontWeight: 500, color: '#8a978f', fontSize: 12.5 }}>(заавал биш)</span></h4>
                <p style={{ margin: '0 0 12px', fontSize: 12.5, color: '#5f6f66' }}>Гражийн QR-аар QPay төлбөр энэ данс руу орно. Хоосон бол дээрх үндсэн данс руу орно. Дансны нэр банкан дээрх бүртгэлтэй <strong>яг адил</strong> байх ёстой.</p>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <div>
                    <label style={labelStyle}>Банк</label>
                    <select value={bankForm.garage_bank_name || ''} onChange={e => setBankForm({ ...bankForm, garage_bank_name: e.target.value })} style={inputStyle}>
                      <option value="">-- Үндсэн данстай адил --</option>
                      {['Төрийн банк', 'Хаан банк', 'Голомт банк', 'Худалдаа хөгжлийн банк', 'Хас банк', 'Капитрон банк', 'Ариг банк', 'Богд банк', 'Тээвэр хөгжлийн банк', 'Үндэсний хөрөнгө оруулалтын банк'].map(b => <option key={b} value={b}>{b}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>Дансны дугаар (IBAN)</label>
                    <input value={bankForm.garage_bank_account_number || ''} onChange={e => setBankForm({ ...bankForm, garage_bank_account_number: e.target.value })} style={inputStyle} placeholder="MN35..." />
                  </div>
                  <div style={{ gridColumn: '1 / -1' }}>
                    <label style={labelStyle}>Данс эзэмшигчийн нэр</label>
                    <input value={bankForm.garage_bank_account_name || ''} onChange={e => setBankForm({ ...bankForm, garage_bank_account_name: e.target.value })} style={inputStyle} placeholder="Гарден 16 СӨХ" />
                  </div>
                </div>
              </div>

              <div style={{ gridColumn: '1 / -1', borderTop: '1px solid #e8e5dc', paddingTop: 16, marginTop: 4 }}>
                <h4 style={{ margin: '0 0 4px', fontWeight: 700, color: '#1c2b22', fontSize: 15 }}>QPay merchant</h4>
                <p style={{ margin: '0 0 12px', fontSize: 12.5, color: '#5f6f66' }}>
                  СӨХ өөрийн QPay гэрээний мэдээллийг оруулна. <strong>Оруулаагүй бол төлбөр
                  энэ СӨХ-ийн данс руу ОРОХГҮЙ</strong> — платформын дансанд орно.
                </p>
                {!bankForm.qpay_username && (
                  <div style={{ background: '#fef3c7', color: '#92400e', padding: '8px 12px', borderRadius: 8, fontSize: 12.5, marginBottom: 12 }}>
                    ⚠️ QPay merchant тохируулаагүй байна — төлбөр энэ СӨХ-ийн дансанд ороогүй байна.
                  </div>
                )}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <div>
                    <label style={labelStyle}>QPay username</label>
                    <input value={bankForm.qpay_username || ''} onChange={e => setBankForm({ ...bankForm, qpay_username: e.target.value })} style={inputStyle} placeholder="NARNY_MN" />
                  </div>
                  <div>
                    <label style={labelStyle}>QPay invoice code</label>
                    <input value={bankForm.qpay_invoice_code || ''} onChange={e => setBankForm({ ...bankForm, qpay_invoice_code: e.target.value })} style={inputStyle} placeholder="NARNY_MN_INVOICE" />
                  </div>
                  <div style={{ gridColumn: '1 / -1' }}>
                    <label style={labelStyle}>
                      QPay нууц үг {bankForm.qpay_password_set && <span style={{ color: '#16a34a', fontWeight: 600 }}>· хадгалагдсан</span>}
                    </label>
                    <input type="password" value={bankForm.qpay_password || ''} onChange={e => setBankForm({ ...bankForm, qpay_password: e.target.value })} style={inputStyle}
                      placeholder={bankForm.qpay_password_set ? 'Солихгүй бол хоосон үлдээнэ' : 'QPay-ээс олгосон нууц үг'} />
                    <p style={{ margin: '4px 0 0', fontSize: 12, color: '#8a978f' }}>Нууц үг шифрлэгдэж хадгалагдана, дахин харагдахгүй.</p>
                  </div>
                </div>
              </div>
            </div>
            {isPlatformAdmin && <button onClick={handleBankSave} style={{ ...btnPrimary, marginTop: 16 }}>Данс хадгалах</button>}
            </fieldset>
          </div>

          {/* QPay — СӨХ-ийг merchant болгож бүртгэх */}
          <div style={{ ...card, marginTop: 16 }}>
            <h3 style={{ margin: '0 0 4px', fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22' }}>QPay төлбөр хүлээн авах</h3>
            <p style={{ margin: '0 0 16px', fontSize: 13, color: '#5f6f66' }}>
              СӨХ-ийг QPay-д бүртгэснээр оршин суугчдын QPay төлбөр <strong>дээрх банкны данс руу шууд</strong> орно.
              Нэг удаа бүртгэнэ. QPay-тэй тусад нь гэрээ хийх шаардлагагүй.
            </p>
            {qpayMsg && <div style={{ ...msgStyle, background: qpayMsg.includes('Алдаа') ? '#fee2e2' : '#f0fdf4', color: qpayMsg.includes('Алдаа') ? '#dc2626' : '#166534' }}>{qpayMsg}</div>}

            {qpayStatus && (
              <div style={{ marginBottom: 14, fontSize: 13.5 }}>
                {qpayStatus.ready ? (
                  <div style={{ background: '#f0fdf4', color: '#166534', padding: '10px 12px', borderRadius: 8 }}>
                    ✅ Бүртгэлтэй — төлбөр <strong>{qpayStatus.bank_name} · {qpayStatus.account_number}</strong> данс руу орно.
                  </div>
                ) : qpayStatus.registered ? (
                  <div style={{ background: '#fef3c7', color: '#92400e', padding: '10px 12px', borderRadius: 8 }}>
                    ⚠️ QPay-д бүртгэлтэй ч банкны данс дутуу байна — дээрх талбарыг бөглөж хадгална уу.
                  </div>
                ) : (
                  <div style={{ background: '#fef3c7', color: '#92400e', padding: '10px 12px', borderRadius: 8 }}>
                    ⚠️ Бүртгэгдээгүй — <strong>төлбөр энэ СӨХ-ийн дансанд ОРОХГҮЙ</strong>.
                    {!qpayStatus.vendor_configured && ' (Платформын QPay тохиргоо дутуу — админд хандана уу.)'}
                  </div>
                )}
              </div>
            )}

            {isPlatformAdmin ? (
              <button onClick={handleQpayRegister} disabled={qpayBusy || !!qpayStatus?.registered || !qpayStatus?.vendor_configured}
                style={{ ...btnPrimary, opacity: (qpayBusy || qpayStatus?.registered || !qpayStatus?.vendor_configured) ? 0.55 : 1 }}>
                {qpayBusy ? 'Бүртгэж байна...' : qpayStatus?.registered ? 'Бүртгэгдсэн' : 'QPay-д бүртгүүлэх'}
              </button>
            ) : (
              <p style={{ margin: 0, fontSize: 12.5, color: '#8a978f' }}>🔒 QPay бүртгэлийг платформын админ хийнэ.</p>
            )}
          </div>

          {/* BPay айл өрхийн код олгох */}
          <div style={{ ...card, marginTop: 16 }}>
            <h3 style={{ margin: '0 0 4px', fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22' }}>BPay айл өрхийн код</h3>
            <p style={{ margin: '0 0 16px', fontSize: 13, color: '#5f6f66' }}>
              Айл өрх бүрт BPay төлбөрт ашиглах давтагдашгүй код олгоно. Оршин суугч банкны апп дээр
              энэ кодоор өөрийн нэхэмжлэхийг олж төлнө. Шинэ айл нэмэгдсэн бол дахин дарж болно.
            </p>
            {billerMsg && <div style={{ ...msgStyle, background: billerMsg.includes('Алдаа') ? '#fee2e2' : '#f0fdf4', color: billerMsg.includes('Алдаа') ? '#dc2626' : '#166534' }}>{billerMsg}</div>}
            <button onClick={handleBackfillCodes} disabled={billerBusy} style={{ ...btnPrimary, opacity: billerBusy ? 0.7 : 1 }}>
              {billerBusy ? 'Олгож байна...' : 'Кодгүй айлуудад код олгох'}
            </button>
          </div>

          {/* Төрийн банкны хаяг (BPay consumer) */}
          <BpayAddressCard card={card} inputStyle={inputStyle} btnPrimary={btnPrimary} msgStyle={msgStyle} />
        </div>
      )}

      {activeTab === 'facebook' && <FacebookUnitsCard card={card} cardTitle={cardTitle} />}
      {activeTab === 'intercom' && <IntercomCard card={card} cardTitle={cardTitle} inputStyle={inputStyle} btnPrimary={btnPrimary} />}

      {/* Billing Settings Tab */}
      {activeTab === 'billing' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
          <div style={card}>
            <h3 style={cardTitle}>Төлбөрийн тохиргоо</h3>
            {settingsMsg && <div style={{ ...msgStyle, background: settingsMsg.includes('Алдаа') ? '#fee2e2' : '#f0fdf4', color: settingsMsg.includes('Алдаа') ? '#dc2626' : '#166534' }}>{settingsMsg}</div>}
            <div style={{ display: 'grid', gap: 14 }}>
              <div>
                <label style={labelStyle}>Төлбөр төлөх хугацаа (сар бүрийн)</label>
                <select value={settingsForm.payment_due_day} onChange={e => setSettingsForm({ ...settingsForm, payment_due_day: Number(e.target.value) })} style={inputStyle}>
                  {Array.from({ length: 28 }, (_, i) => <option key={i + 1} value={i + 1}>{i + 1}-ний өдөр</option>)}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Нэхэмжлэх үүсгэх өдөр</label>
                <select value={settingsForm.billing_collect_day} onChange={e => setSettingsForm({ ...settingsForm, billing_collect_day: Number(e.target.value) })} style={inputStyle}>
                  {Array.from({ length: 28 }, (_, i) => <option key={i + 1} value={i + 1}>{i + 1}-ний өдөр</option>)}
                </select>
              </div>
            </div>
            <button onClick={handleSettingsSave} style={{ ...btnPrimary, marginTop: 16 }}>Хадгалах</button>
          </div>

          <div style={card}>
            <h3 style={cardTitle}>Алданги тохиргоо</h3>
            <div style={{ display: 'grid', gap: 14 }}>
              <div>
                <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: 8 }}>
                  <input type="checkbox" checked={settingsForm.late_fee_enabled} onChange={e => setSettingsForm({ ...settingsForm, late_fee_enabled: e.target.checked })} />
                  Алданги тооцох
                </label>
              </div>
              {settingsForm.late_fee_enabled && (
                <>
                  <div>
                    <label style={labelStyle}>Алдангийн хувь (%)</label>
                    <input type="number" step="0.1" min="0" max="10" value={settingsForm.late_fee_percent}
                      onChange={e => setSettingsForm({ ...settingsForm, late_fee_percent: parseFloat(e.target.value) || 0 })} style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>Алданги эхлэх хоног (хугацаа хэтэрсэнээс)</label>
                    <input type="number" min="1" max="90" value={settingsForm.late_fee_start_days}
                      onChange={e => setSettingsForm({ ...settingsForm, late_fee_start_days: parseInt(e.target.value) || 30 })} style={inputStyle} />
                  </div>
                </>
              )}
            </div>
            <button onClick={handleSettingsSave} style={{ ...btnPrimary, marginTop: 16 }}>Хадгалах</button>
          </div>
        </div>
      )}

      {/* Email Tab */}
      {activeTab === 'email' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
          <div style={card}>
            <h3 style={cardTitle}>Имэйл тохиргоо</h3>
            <div style={{
              padding: 16, borderRadius: 8, marginBottom: 16,
              background: emailStatus?.configured ? '#f0fdf4' : '#fef9c3',
              border: emailStatus?.configured ? '1px solid #bbf7d0' : '1px solid #fde68a',
            }}>
              <div style={{ fontWeight: 600, fontSize: 14, color: emailStatus?.configured ? '#166534' : '#92400e', marginBottom: 4 }}>
                {emailStatus?.configured ? 'SMTP тохируулагдсан' : 'Демо горим (имэйл илгээхгүй)'}
              </div>
              <div style={{ fontSize: 13, color: '#5f6f66' }}>
                {emailStatus?.configured
                  ? `${emailStatus.from_name} <${emailStatus.from_email}>`
                  : 'Имэйл илгээхийг идэвхжүүлэхийн тулд SMTP тохиргоог оруулна уу.'}
              </div>
            </div>
            {emailStatus && (
              <div style={{ display: 'grid', gap: 12 }}>
                <InfoRow label="SMTP сервер" value={`${emailStatus.smtp_host}:${emailStatus.smtp_port}`} />
                <InfoRow label="Нэр" value={emailStatus.from_name || '-'} />
                <InfoRow label="Хэрэглэгч" value={emailStatus.smtp_user || '(тохируулаагүй)'} />
              </div>
            )}
          </div>
          <div style={card}>
            <h3 style={cardTitle}>SMTP тохируулах заавар</h3>
            <div style={{ fontSize: 13, color: '#333', lineHeight: 1.8 }}>
              <p style={{ margin: '0 0 8px' }}>Railway дээрх env variable-д дараах утгуудыг нэмнэ:</p>
              <div style={{ background: '#f8f8f8', borderRadius: 8, padding: 12, fontFamily: 'monospace', fontSize: 12, marginBottom: 12 }}>
                SMTP_USER=your@gmail.com<br/>
                SMTP_PASSWORD=xxxx xxxx xxxx xxxx<br/>
                SMTP_FROM_EMAIL=your@gmail.com
              </div>
              <p style={{ margin: '0 0 4px', fontWeight: 600 }}>Gmail App Password авах:</p>
              <ol style={{ margin: 0, paddingLeft: 20 }}>
                <li>Google Account &rarr; Security</li>
                <li>2-Step Verification идэвхжүүлэх</li>
                <li>App Passwords &rarr; "Mail" сонгох</li>
                <li>16 тэмдэгтийн password-г хуулах</li>
              </ol>
            </div>
          </div>
        </div>
      )}

      {/* Audit Logs Tab */}
      {activeTab === 'audit' && (
        <div style={card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h3 style={{ ...cardTitle, margin: 0 }}>Үйл ажиллагааны лог ({auditTotal})</h3>
            <button onClick={loadAuditLogs} style={{ ...btnSecondary }}>Шинэчлэх</button>
          </div>
          {auditLoading ? <p style={{ color: '#5f6f66' }}>Уншиж байна...</p> : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #e8e5dc', textAlign: 'left' }}>
                    <th style={th}>Огноо</th>
                    <th style={th}>Үйлдэл</th>
                    <th style={th}>Төрөл</th>
                    <th style={th}>Дэлгэрэнгүй</th>
                  </tr>
                </thead>
                <tbody>
                  {auditLogs.map((log: any) => (
                    <tr key={log.id} style={{ borderBottom: '1px solid #e8e5dc' }}>
                      <td style={{ ...td, fontSize: 12, color: '#5f6f66', whiteSpace: 'nowrap' }}>
                        {log.created_at ? new Date(log.created_at).toLocaleString('mn-MN') : '-'}
                      </td>
                      <td style={td}>
                        <span style={{
                          background: '#f0fdf4', color: '#236844',
                          padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600,
                        }}>
                          {ACTION_LABELS[log.action] || log.action}
                        </span>
                      </td>
                      <td style={{ ...td, fontSize: 13 }}>{log.resource_type || '-'}</td>
                      <td style={{ ...td, fontSize: 12, color: '#5f6f66', maxWidth: 300 }}>
                        {log.new_values ? (
                          <span title={JSON.stringify(log.new_values)}>
                            {Object.entries(log.new_values).slice(0, 3).map(([k, v]) => `${k}: ${v}`).join(', ')}
                          </span>
                        ) : '-'}
                      </td>
                    </tr>
                  ))}
                  {auditLogs.length === 0 && (
                    <tr><td colSpan={4} style={{ ...td, textAlign: 'center', color: '#94a3b8' }}>Лог олдсонгүй</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Platform Tab — зөвхөн платформ админ */}
      {activeTab === 'platform' && isPlatformAdmin && (
        <div>
        <div style={card}>
          <h3 style={{ margin: '0 0 4px', fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22' }}>QPay Vendor тохиргоо</h3>
          <p style={{ margin: '0 0 16px', fontSize: 13, color: '#5f6f66' }}>
            Платформын QPay vendor гэрээний холболт. Энд хадгалсан тохиргоо <strong>шууд хэрэглэгдэнэ</strong> —
            Railway env солих, redeploy хийх шаардлагагүй.
          </p>
          {vendorCfg && (
            <div style={{
              display: 'inline-block', padding: '6px 14px', borderRadius: 8, fontSize: 13, fontWeight: 600, marginBottom: 16,
              background: vendorCfg.environment === 'production' ? '#f0fdf4' : '#fef3c7',
              color: vendorCfg.environment === 'production' ? '#166534' : '#92400e',
            }}>
              {vendorCfg.environment === 'production' ? '🟢 PRODUCTION орчин' : '🟡 SANDBOX (тест) орчин — бодит төлбөр хийгдэхгүй'}
            </div>
          )}
          {vendorMsg && <div style={{ ...msgStyle, background: vendorMsg.includes('Алдаа') ? '#fee2e2' : '#f0fdf4', color: vendorMsg.includes('Алдаа') ? '#dc2626' : '#166534' }}>{vendorMsg}</div>}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, maxWidth: 720 }}>
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={labelStyle}>Vendor URL</label>
              <select value={vendorForm.url} onChange={e => setVendorForm({ ...vendorForm, url: e.target.value })} style={inputStyle}>
                <option value="https://sandbox-quickqr.qpay.mn">https://sandbox-quickqr.qpay.mn (тест)</option>
                <option value="https://quickqr.qpay.mn">https://quickqr.qpay.mn (production)</option>
              </select>
            </div>
            <div>
              <label style={labelStyle}>Хэрэглэгчийн нэр</label>
              <input value={vendorForm.username} onChange={e => setVendorForm({ ...vendorForm, username: e.target.value })} style={inputStyle} placeholder="VENDOR_USERNAME" />
            </div>
            <div>
              <label style={labelStyle}>Terminal ID</label>
              <input value={vendorForm.terminal_id} onChange={e => setVendorForm({ ...vendorForm, terminal_id: e.target.value })} style={inputStyle} placeholder="95000059" />
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={labelStyle}>
                Нууц үг {vendorCfg?.password_set && <span style={{ color: '#16a34a', fontWeight: 600 }}>· хадгалагдсан</span>}
              </label>
              <input type="password" value={vendorForm.password} onChange={e => setVendorForm({ ...vendorForm, password: e.target.value })} style={inputStyle}
                placeholder={vendorCfg?.password_set ? 'Солихгүй бол хоосон үлдээнэ' : 'QPay-ээс өгсөн нууц үг'} />
              <p style={{ margin: '4px 0 0', fontSize: 12, color: '#8a978f' }}>Шифрлэгдэж хадгалагдана, дахин харагдахгүй.</p>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
            <button onClick={handleVendorSave} disabled={vendorBusy} style={{ ...btnPrimary, opacity: vendorBusy ? 0.6 : 1 }}>
              {vendorBusy ? 'Хадгалж байна...' : 'Хадгалах'}
            </button>
            <button onClick={handleVendorTest} disabled={vendorBusy} style={{
              background: '#eff6ff', color: '#2563eb', border: 'none', padding: '8px 20px',
              borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, opacity: vendorBusy ? 0.6 : 1,
            }}>Холболт шалгах</button>
          </div>
          <div style={{ marginTop: 16, padding: '10px 14px', background: '#fffbeb', borderRadius: 8, fontSize: 12.5, color: '#92400e' }}>
            ⚠️ Production руу шилжихдээ 4 талбарыг БҮГДИЙГ production утгаар солино — sandbox-ын
            нэр/нууц үг production дээр ажиллахгүй. Мөн СӨХ бүр production дээр дахин "QPay-д
            бүртгүүлэх" дарах шаардлагатай (sandbox merchant ID шинэ орчинд хүчингүй).
          </div>
        </div>

          {/* Өгөгдлийн сангийн нөөц (backup) */}
          <div style={{ ...card, marginTop: 16 }}>
            <h3 style={{ margin: '0 0 4px', fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22' }}>Өгөгдлийн сангийн нөөц (Backup)</h3>
            <p style={{ margin: '0 0 12px', fontSize: 13, color: '#5f6f66' }}>
              Долоо хоног тутам автоматаар бүх өгөгдлийг SQL болгон нөөцлөж, R2-д хадгалж, имэйлээр илгээнэ.
              Доорх товчоор одоо шууд нөөц хийж болно.
            </p>
            {backupStatus && (
              <div style={{ fontSize: 13, color: '#5f6f66', marginBottom: 12, display: 'grid', gap: 4 }}>
                <div>Автомат нөөц: <b style={{ color: backupStatus.enabled ? '#166534' : '#dc2626' }}>{backupStatus.enabled ? `${backupStatus.interval_days} хоног тутам` : 'идэвхгүй'}</b></div>
                <div>Имэйл хаяг: <b>{backupStatus.email || <span style={{ color: '#dc2626' }}>тохируулаагүй (BACKUP_EMAIL)</span>}</b></div>
                <div>Сүүлийн нөөц: <b>{backupStatus.last_backup_at ? new Date(backupStatus.last_backup_at).toLocaleString('mn-MN') : 'хараахан үгүй'}</b></div>
              </div>
            )}
            {backupMsg && <div style={{ ...msgStyle, background: backupMsg.includes('Алдаа') ? '#fee2e2' : '#f0fdf4', color: backupMsg.includes('Алдаа') ? '#dc2626' : '#166534' }}>{backupMsg}</div>}
            <button onClick={runBackup} disabled={backupBusy} style={{ ...btnPrimary, opacity: backupBusy ? 0.6 : 1 }}>
              {backupBusy ? 'Нөөц хийж байна...' : '💾 Одоо нөөц хийх'}
            </button>
          </div>

          <MassSmsCard />

          {/* СӨХ-үүдийн төлбөр хүлээн авах данс — зөвхөн эндээс засна */}
          <div style={{ ...card, marginTop: 16 }}>
            <h3 style={{ margin: '0 0 4px', fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22' }}>СӨХ-ийн төлбөр хүлээн авах данс</h3>
            <p style={{ margin: '0 0 16px', fontSize: 13, color: '#5f6f66' }}>
              СӨХ бүрийн банкны данс, QPay/BPay холболтыг зөвхөн платформын админ эндээс удирдана.
              СӨХ-ийн эрхтнүүд өөрсдийн Тохиргоо хуудаснаас зөвхөн харна.
            </p>
            {paMsg && <div style={{ ...msgStyle, background: paMsg.includes('Алдаа') ? '#fee2e2' : '#f0fdf4', color: paMsg.includes('Алдаа') ? '#dc2626' : '#166534' }}>{paMsg}</div>}
            <div style={{ maxWidth: 720 }}>
              <label style={labelStyle}>СӨХ сонгох</label>
              <select value={paTenantId} onChange={e => loadPaTenant(e.target.value)} style={{ ...inputStyle, marginBottom: 16 }}>
                <option value="">-- СӨХ сонгох --</option>
                {paTenants.map((t: any) => <option key={t.id} value={t.id}>{t.name}</option>)}
              </select>

              {paBank && (
                <>
                  {paStatus && (
                    <div style={{
                      padding: '8px 12px', borderRadius: 8, fontSize: 13, marginBottom: 14,
                      background: paStatus.ready ? '#f0fdf4' : '#fef3c7',
                      color: paStatus.ready ? '#166534' : '#92400e',
                    }}>
                      {paStatus.ready
                        ? `✅ QPay бэлэн — төлбөр ${paStatus.bank_name} · ${paStatus.account_number} данс руу орно`
                        : paStatus.registered
                          ? '⚠️ QPay бүртгэлтэй ч данс дутуу'
                          : '⚠️ QPay-д бүртгэгдээгүй — төлбөр СӨХ-ийн дансанд ОРОХГҮЙ'}
                    </div>
                  )}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                    <div>
                      <label style={labelStyle}>Банк</label>
                      <select value={paBank.bank_name} onChange={e => setPaBank({ ...paBank, bank_name: e.target.value })} style={inputStyle}>
                        <option value="">-- Сонгох --</option>
                        {['Төрийн банк', 'Хаан банк', 'Голомт банк', 'Худалдаа хөгжлийн банк', 'Хас банк', 'Капитрон банк', 'Ариг банк', 'Богд банк', 'Тээвэр хөгжлийн банк', 'Үндэсний хөрөнгө оруулалтын банк'].map(b => <option key={b} value={b}>{b}</option>)}
                      </select>
                    </div>
                    <div>
                      <label style={labelStyle}>Дансны дугаар (IBAN)</label>
                      <input value={paBank.bank_account_number} onChange={e => setPaBank({ ...paBank, bank_account_number: e.target.value })} style={inputStyle} placeholder="MN35..." />
                    </div>
                    <div>
                      <label style={labelStyle}>Данс эзэмшигчийн нэр</label>
                      <input value={paBank.bank_account_name} onChange={e => setPaBank({ ...paBank, bank_account_name: e.target.value })} style={inputStyle} />
                    </div>
                    <div>
                      <label style={labelStyle}>BPay biller код</label>
                      <input value={paBank.bpay_biller_code} onChange={e => setPaBank({ ...paBank, bpay_biller_code: e.target.value })} style={inputStyle} />
                    </div>
                    <div style={{ gridColumn: '1 / -1', borderTop: '1px solid #e8e5dc', paddingTop: 16, marginTop: 4 }}>
                <h4 style={{ margin: '0 0 4px', fontWeight: 700, color: '#1c2b22', fontSize: 15 }}>Гражийн төлбөр хүлээн авах данс <span style={{ fontWeight: 500, color: '#8a978f', fontSize: 12.5 }}>(заавал биш)</span></h4>
                <p style={{ margin: '0 0 12px', fontSize: 12.5, color: '#5f6f66' }}>Гражийн QR-аар QPay төлбөр энэ данс руу орно. Хоосон бол дээрх үндсэн данс руу орно. Дансны нэр банкан дээрх бүртгэлтэй <strong>яг адил</strong> байх ёстой.</p>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <div>
                    <label style={labelStyle}>Банк</label>
                    <select value={paBank.garage_bank_name || ''} onChange={e => setPaBank({ ...paBank, garage_bank_name: e.target.value })} style={inputStyle}>
                      <option value="">-- Үндсэн данстай адил --</option>
                      {['Төрийн банк', 'Хаан банк', 'Голомт банк', 'Худалдаа хөгжлийн банк', 'Хас банк', 'Капитрон банк', 'Ариг банк', 'Богд банк', 'Тээвэр хөгжлийн банк', 'Үндэсний хөрөнгө оруулалтын банк'].map(b => <option key={b} value={b}>{b}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>Дансны дугаар (IBAN)</label>
                    <input value={paBank.garage_bank_account_number || ''} onChange={e => setPaBank({ ...paBank, garage_bank_account_number: e.target.value })} style={inputStyle} placeholder="MN35..." />
                  </div>
                  <div style={{ gridColumn: '1 / -1' }}>
                    <label style={labelStyle}>Данс эзэмшигчийн нэр</label>
                    <input value={paBank.garage_bank_account_name || ''} onChange={e => setPaBank({ ...paBank, garage_bank_account_name: e.target.value })} style={inputStyle} placeholder="Гарден 16 СӨХ" />
                  </div>
                </div>
              </div>

                  </div>
                  <div style={{ display: 'flex', gap: 10, marginTop: 16, flexWrap: 'wrap' }}>
                    <button onClick={handlePaBankSave} disabled={paBusy} style={{ ...btnPrimary, opacity: paBusy ? 0.6 : 1 }}>
                      {paBusy ? 'Хадгалж байна...' : 'Данс хадгалах'}
                    </button>
                    {!paStatus?.registered ? (
                      <button onClick={() => handlePaQpayRegister(false)} disabled={paBusy} style={{
                        background: '#eff6ff', color: '#2563eb', border: 'none', padding: '8px 20px',
                        borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, opacity: paBusy ? 0.6 : 1,
                      }}>QPay-д бүртгүүлэх</button>
                    ) : (
                      <button onClick={() => handlePaQpayRegister(true)} disabled={paBusy} title="Орчин (sandbox→production) солигдсон бол дахин бүртгэнэ" style={{
                        background: '#fff7ed', color: '#c2410c', border: 'none', padding: '8px 20px',
                        borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, opacity: paBusy ? 0.6 : 1,
                      }}>↻ Дахин бүртгэх (орчин солигдсон бол)</button>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}


      {/* System Info */}
      <div style={{ ...card, marginTop: 20 }}>
        <h3 style={cardTitle}>Системийн мэдээлэл</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
          <InfoRow label="Платформ" value="Сайн хөрш v1.0" />
          <InfoRow label="API хувилбар" value="v1" />
          <InfoRow label="Тусламж" value="nationalmobile976@gmail.com" />
        </div>
      </div>
    </div>
  );
}

function InfoRow({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div style={{ fontSize: 12, color: '#5f6f66', marginBottom: 2 }}>{label}</div>
      <div style={{ fontSize: 14, color: '#1c2b22', fontWeight: 500 }}>{value}</div>
    </div>
  );
}

const card: React.CSSProperties = {
  background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
};
const cardTitle: React.CSSProperties = {
  fontFamily: "'Inter'", fontSize: 16, fontWeight: 600, color: '#1c2b22', marginTop: 0, marginBottom: 20,
};
const btnPrimary: React.CSSProperties = {
  background: 'linear-gradient(180deg, #2f7d52, #236844)', color: '#fff', border: 'none',
  padding: '10px 20px', borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, fontFamily: "'Inter'",
};
const btnSecondary: React.CSSProperties = {
  background: '#e8e5dc', color: '#2a3b32', border: 'none',
  padding: '8px 16px', borderRadius: 8, cursor: 'pointer', fontWeight: 500, fontSize: 13,
};
const labelStyle: React.CSSProperties = { display: 'block', marginBottom: 6, fontSize: 13, color: '#2a3b32', fontWeight: 500 };
const inputStyle: React.CSSProperties = {
  width: '100%', padding: '10px 14px', border: '1.5px solid #dcdacf', borderRadius: 10,
  fontSize: 14, boxSizing: 'border-box', background: '#fbfaf6',
};
const msgStyle: React.CSSProperties = { padding: '8px 14px', borderRadius: 8, marginBottom: 12, fontSize: 13 };
const th: React.CSSProperties = { padding: '10px 12px', fontSize: 13, color: '#5f6f66', fontWeight: 600 };
const td: React.CSSProperties = { padding: '10px 12px', fontSize: 14, color: '#1c2b22' };


/** Төрийн банкны (BPay) хаягийн лавлахаас СӨХ-ийн байрыг сонгох — хот → дүүрэг → хороо → байр.
 *  Тохируулсны дараа оршин суугчийн QR хуудсанд «Цахилгаан · Дулаан · СӨХ нэхэмжлэх» гарна. */
function BpayAddressCard({ card, inputStyle, btnPrimary, msgStyle }: { card: any; inputStyle: any; btnPrimary: any; msgStyle: any }) {
  type Opt = { id: string; name: string };
  const [cur, setCur] = useState<{ bair_id: string; label: string; configured: boolean } | null>(null);
  const [cities, setCities] = useState<Opt[]>([]); const [districts, setDistricts] = useState<Opt[]>([]);
  const [khoroos, setKhoroos] = useState<Opt[]>([]); const [bairs, setBairs] = useState<Opt[]>([]);
  const [city, setCity] = useState(''); const [district, setDistrict] = useState(''); const [khoroo, setKhoroo] = useState(''); const [bair, setBair] = useState('');
  const [editing, setEditing] = useState(false); const [busy, setBusy] = useState(false); const [msg, setMsg] = useState('');
  const [door, setDoor] = useState('1'); const [preview, setPreview] = useState<any[] | null>(null);
  const unwrap = (r: any): Opt[] => { const d = r?.data ?? r; const arr = Array.isArray(d) ? d : (d?.data || []); return arr.map((x: any) => ({ id: x.id, name: x.name })); };

  useEffect(() => { api.get('/admin/bpay/address').then(r => setCur(r)).catch(() => setCur({ bair_id: '', label: '', configured: false })); }, []);
  const startEdit = async () => { setEditing(true); setMsg(''); try { setCities(unwrap(await api.get('/admin/bpay/address/cities'))); } catch (e: any) { setMsg('Алдаа: ' + (errText(e, 'хаягийн лавлах авч чадсангүй'))); } };
  const pickCity = async (id: string) => { setCity(id); setDistrict(''); setKhoroo(''); setBair(''); setKhoroos([]); setBairs([]); if (id) setDistricts(unwrap(await api.get(`/admin/bpay/address/districts/${id}`))); };
  const pickDistrict = async (id: string) => { setDistrict(id); setKhoroo(''); setBair(''); setBairs([]); if (id) setKhoroos(unwrap(await api.get(`/admin/bpay/address/khoroos/${id}`))); };
  const pickKhoroo = async (id: string) => { setKhoroo(id); setBair(''); if (id) setBairs(unwrap(await api.get(`/admin/bpay/address/bairs/${id}`))); };
  const save = async () => {
    const b = bairs.find(x => x.id === bair); if (!b) return;
    setBusy(true); setMsg('');
    try { const r = await api.put('/admin/bpay/address', { bair_id: bair, label: b.name }); setCur({ ...(cur || { configured: true }), ...r } as any); setEditing(false); setMsg('Хаяг хадгалагдлаа. Оршин суугчийн QR хуудсанд нэхэмжлэх хайлт идэвхжсэн.'); setPreview(null); }
    catch (e: any) { setMsg('Алдаа: ' + (errText(e, 'хадгалж чадсангүй'))); } finally { setBusy(false); }
  };
  const clear = async () => { setBusy(true); try { await api.put('/admin/bpay/address', { bair_id: '', label: '' }); setCur({ bair_id: '', label: '', configured: cur?.configured ?? true }); setPreview(null); setMsg('Хаяг цэвэрлэгдлээ.'); } finally { setBusy(false); } };
  const check = async () => { setBusy(true); setMsg(''); try { const r = await api.get(`/admin/bpay/address/preview/${encodeURIComponent(door.trim() || '1')}`); setPreview(r.customers || []); if (r.message) setMsg(r.message); } catch (e: any) { setMsg('Алдаа: ' + (errText(e, 'шалгаж чадсангүй'))); } finally { setBusy(false); } };
  const sel = (v: string, on: (x: string) => void, opts: Opt[], ph: string, dis = false) => (
    <select value={v} onChange={e => on(e.target.value)} disabled={dis} style={{ ...inputStyle, appearance: 'auto' }}><option value="">{ph}</option>{opts.map(o => <option key={o.id} value={o.id}>{o.name}</option>)}</select>
  );
  return (
    <div style={{ ...card, marginTop: 16 }}>
      <h3 style={{ margin: '0 0 4px', fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22' }}>Төрийн банкны хаяг (цахилгаан, дулаан, СӨХ нэхэмжлэх)</h3>
      <p style={{ margin: '0 0 14px', fontSize: 13, color: '#5f6f66' }}>
        СӨХ-ийн байрыг Төрийн банкны хаягийн лавлахаас сонгоно. Тохируулсны дараа оршин суугч QR уншуулаад тоотынхоо
        Төрийн банкны нэхэмжлэхүүдийг (СӨХ, дулаан, цахилгаан) харж QPay-ээр төлөх боломжтой болно.
      </p>
      {msg && <div style={{ ...msgStyle, background: msg.startsWith('Алдаа') ? '#fee2e2' : '#f0fdf4', color: msg.startsWith('Алдаа') ? '#dc2626' : '#166534' }}>{msg}</div>}
      {cur && !cur.configured && <div style={{ ...msgStyle, background: '#fef3c7', color: '#92400e' }}>BPay холболт серверт тохируулагдаагүй байна (BPAY_* env).</div>}
      {!editing ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: 220 }}>
            <div style={{ fontSize: 12, color: '#5f6f66' }}>Сонгосон байр</div>
            <div style={{ fontWeight: 600, color: '#1c2b22' }}>{cur?.label || (cur ? 'Тохируулаагүй' : '…')}</div>
          </div>
          <button onClick={startEdit} style={btnPrimary}>{cur?.bair_id ? 'Хаяг солих' : 'Хаяг сонгох'}</button>
          {cur?.bair_id && <button onClick={clear} disabled={busy} style={{ ...btnPrimary, background: '#fff', color: '#dc2626', border: '1px solid #fecaca' }}>Цэвэрлэх</button>}
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 10 }}>
          {sel(city, pickCity, cities, 'Хот / аймаг')}
          {sel(district, pickDistrict, districts, 'Дүүрэг / сум', !city)}
          {sel(khoroo, pickKhoroo, khoroos, 'Хороо', !district)}
          {sel(bair, setBair, bairs, 'Байр', !khoroo)}
          <div style={{ gridColumn: '1 / -1', display: 'flex', gap: 10 }}>
            <button onClick={save} disabled={!bair || busy} style={{ ...btnPrimary, opacity: !bair || busy ? .6 : 1 }}>Хадгалах</button>
            <button onClick={() => setEditing(false)} style={{ ...btnPrimary, background: '#fff', color: '#1c2b22', border: '1px solid #e5e7eb' }}>Болих</button>
          </div>
        </div>
      )}
      {cur?.bair_id && !editing && (
        <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px solid #eef0ec' }}>
          <div style={{ fontSize: 13, color: '#5f6f66', marginBottom: 6 }}>Шалгах: тоотоор Төрийн банкны хэрэглэгч хайж, зөв байр эсэхийг батлах</div>
          <div style={{ display: 'flex', gap: 8 }}>
            <input value={door} onChange={e => setDoor(e.target.value)} style={{ ...inputStyle, width: 120 }} placeholder="Тоот" />
            <button onClick={check} disabled={busy} style={btnPrimary}>Хайх</button>
          </div>
          {preview && (
            <div style={{ marginTop: 10, fontSize: 13 }}>
              {preview.length === 0 ? <span style={{ color: '#92400e' }}>Энэ тоотод хэрэглэгч олдсонгүй — байр эсвэл тоотыг шалгана уу.</span>
                : preview.map((c: any) => <div key={c.customerId} style={{ padding: '6px 0', borderBottom: '1px solid #f1f3ef' }}><b>{c.customerName}</b> <span style={{ color: '#5f6f66' }}>· {c.customerAddress} · {c.customerCode}</span></div>)}
            </div>
          )}
        </div>
      )}
    </div>
  );
}


/** Дүүргийн лого + дүүрэг/хорооны нэр — оршин суугчийн QR хуудасны толгойд СӨХ-ийн баруун талд харагдана (ж: БЗД · 16-р хороо). */
/** Facebook холболт — QR хуудаснаас Messenger чат эхлүүлсэн оршин суугчдын жагсаалт (unit_facebook_contacts).
 *  Нэг тоотод олон хүн (эзэмшигч, түрээслэгч, гэр бүл) холбогдож болно — тус бүр тусдаа мөр. */
function FacebookUnitsCard({ card, cardTitle }: { card: any; cardTitle: any }) {
  const [rows, setRows] = useState<any[] | null>(null);
  const [q, setQ] = useState('');
  const load = () => api.get<any[]>('/admin/facebook/contacts').then(r => setRows(r || [])).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const fmt = (v: any) => fmtDateTime(v);
  const remove = async (c: any) => {
    if (!window.confirm(`${c.building} байр, ${c.unit_number} тоотоос ${c.name || 'ID ' + c.psid}-г хасах уу?`)) return;
    try { await api.delete(`/admin/facebook/contacts/${c.id}`); load(); } catch (e: any) { alert(e?.message || 'Алдаа'); }
  };
  const shown = (rows || []).filter(c => !q || `${c.building} ${c.unit_number} ${c.owner_name} ${c.phone} ${c.name} ${c.psid}`.toLowerCase().includes(q.toLowerCase()));
  const units = new Set(shown.map(c => c.unit_id)).size;
  return (
    <div style={card}>
      <h3 style={cardTitle}>Facebook холболттой айлууд {rows ? `(${units} тоот, ${rows.length} хүн)` : ''}</h3>
      <div style={{ fontSize: 13, color: '#5f6f66', marginBottom: 12 }}>Оршин суугч QR хуудасны «Messenger-ээр бичих» товчоор чат эхлүүлмэгц Facebook нь манай серверт мэдэгдэж, тухайн тоотод Facebook ID, нэр нь <b>автоматаар</b> холбогдоно. Нэг тоотод хэд хэдэн хүн (эзэмшигч, түрээслэгч, гэр бүлийн гишүүн) холбогдож болно. «Чат нээх» дарж тухайн хүнтэй хуудасны Inbox-оос ярина.</div>
      <input value={q} onChange={e => setQ(e.target.value)} placeholder="Тоот, эзэмшигч, утас, Facebook нэр/ID-аар хайх…" style={{ width: '100%', padding: '9px 12px', border: '1px solid #cbd5e1', borderRadius: 8, marginBottom: 12, boxSizing: 'border-box' }} />
      {rows === null ? <div style={{ color: '#5f6f66' }}>Уншиж байна…</div> : shown.length === 0 ? <div style={{ color: '#5f6f66', padding: 16, textAlign: 'center', border: '1px dashed #cbd5e1', borderRadius: 8 }}>Facebook холбогдсон айл алга.</div> : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead><tr style={{ background: '#f8fafc', color: '#475569' }}>
              <th style={{ textAlign: 'left', padding: '8px 10px' }}>Байр / Тоот</th><th style={{ textAlign: 'left', padding: '8px 10px' }}>Эзэмшигч</th><th style={{ textAlign: 'left', padding: '8px 10px' }}>Утас</th><th style={{ textAlign: 'left', padding: '8px 10px' }}>Facebook</th><th style={{ textAlign: 'left', padding: '8px 10px' }}>Холбогдсон</th><th style={{ textAlign: 'left', padding: '8px 10px' }}>Сүүлд бичсэн</th><th></th>
            </tr></thead>
            <tbody>{shown.map((c, i) => {
              const first = i === 0 || shown[i - 1].unit_id !== c.unit_id;
              return (
              <tr key={c.id} style={{ borderTop: first ? '1px solid #e2e8f0' : '1px dashed #f1f5f9' }}>
                <td style={{ padding: '8px 10px', fontWeight: 600, color: first ? undefined : '#94a3b8' }}>{first ? `${c.building} байр, ${c.unit_number} тоот` : '〃'}</td>
                <td style={{ padding: '8px 10px' }}>{first ? (c.owner_name || '—') : ''}</td>
                <td style={{ padding: '8px 10px' }}>{first ? (c.phone || '—') : ''}</td>
                <td style={{ padding: '8px 10px', wordBreak: 'break-all' }}>
                  {c.name ? <div style={{ fontWeight: 600 }}>{c.name}</div>
                    : <div style={{ fontWeight: 600, color: '#64748b' }} title="Meta App Review (pages_messaging) батлагдтал Facebook нэрийг зөвхөн аппын админ/тестер хэрэглэгчдэд өгдөг">Холбогдсон (нэр хараахан авагдаагүй)</div>}
                  <div style={{ fontSize: 12, color: '#64748b' }}>ID {c.psid}{c.message_count ? ` · ${c.message_count} мессеж` : ''}</div>
                </td>
                <td style={{ padding: '8px 10px', whiteSpace: 'nowrap', fontSize: 12.5, color: '#64748b' }}>{fmt(c.linked_at)}</td>
                <td style={{ padding: '8px 10px', whiteSpace: 'nowrap', fontSize: 12.5, color: '#64748b' }}>{fmt(c.last_seen_at)}</td>
                <td style={{ padding: '8px 10px', whiteSpace: 'nowrap', display: 'flex', gap: 6 }}>
                  <a href={`https://www.facebook.com/messages/t/${c.psid}`} target="_blank" rel="noreferrer" style={{ background: '#1877F2', color: '#fff', padding: '5px 10px', borderRadius: 6, textDecoration: 'none', fontSize: 12.5, fontWeight: 600 }}>Чат нээх</a>
                  <button onClick={() => remove(c)} title="Энэ холболтыг хасах" style={{ background: '#fff', color: '#b91c1c', border: '1px solid #fecaca', padding: '5px 8px', borderRadius: 6, fontSize: 12.5, cursor: 'pointer' }}>Хасах</button>
                </td>
              </tr>);
            })}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function DistrictCard({ card, cardTitle, inputStyle, btnPrimary, msgStyle, initial }: { card: any; cardTitle: any; inputStyle: any; btnPrimary: any; msgStyle: any; initial: { district: string; khoroo: string; logo: string } }) {
  const API_ORIGIN = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1').replace(/\/api\/v1\/?$/, '');
  const [district, setDistrict] = useState(initial.district); const [khoroo, setKhoroo] = useState(initial.khoroo);
  const [logo, setLogo] = useState(initial.logo); const [busy, setBusy] = useState(false); const [msg, setMsg] = useState('');
  const fileRef = React.useRef<HTMLInputElement>(null);
  const hdr = () => ({ Authorization: `Bearer ${localStorage.getItem('admin_token') || ''}`, ...(localStorage.getItem('platform_tenant_id') ? { 'X-Tenant-Id': localStorage.getItem('platform_tenant_id') as string } : {}) });
  const save = async () => {
    setBusy(true); setMsg('');
    try { await api.put('/admin/settings', { district: district.trim(), khoroo: khoroo.trim() }); setMsg('Хадгалагдлаа — QR хуудсанд харагдана.'); }
    catch (e: any) { setMsg('Алдаа: ' + errText(e, 'хадгалж чадсангүй')); } finally { setBusy(false); }
  };
  const upload = async (f: File | undefined) => {
    if (!f) return; setBusy(true); setMsg('');
    try { const fd = new FormData(); fd.append('file', f); const r = await fetch(`${API_ORIGIN}/api/v1/admin/settings/district-logo`, { method: 'POST', headers: hdr(), body: fd }); const d = await r.json(); if (!r.ok) throw new Error(d.detail || 'Алдаа'); setLogo(d.district_logo_url); setMsg('Лого хадгалагдлаа.'); }
    catch (e: any) { setMsg('Алдаа: ' + (e.message || 'лого хуулж чадсангүй')); } finally { setBusy(false); if (fileRef.current) fileRef.current.value = ''; }
  };
  const remove = async () => { if (!window.confirm('Дүүргийн логог устгах уу?')) return; setBusy(true); try { await api.delete('/admin/settings/district-logo'); setLogo(''); setMsg('Лого устгагдлаа.'); } catch (e: any) { setMsg('Алдаа: ' + errText(e, 'устгаж чадсангүй')); } finally { setBusy(false); } };
  return (
    <div style={card}>
      <h3 style={cardTitle}>Дүүргийн лого, хаяг (QR хуудас)</h3>
      <p style={{ margin: '0 0 12px', fontSize: 13, color: '#5f6f66' }}>Оршин суугчийн QR хуудасны толгойд СӨХ-ийн нэрийн баруун талд дүүргийн лого болон «БЗД · 16-р хороо» гэж харагдана.</p>
      {msg && <div style={{ ...msgStyle, background: msg.startsWith('Алдаа') ? '#fee2e2' : '#f0fdf4', color: msg.startsWith('Алдаа') ? '#dc2626' : '#166534' }}>{msg}</div>}
      <div style={{ display: 'flex', gap: 14, alignItems: 'center', marginBottom: 14 }}>
        <div style={{ width: 72, height: 72, borderRadius: 12, border: '1px solid #e5e7eb', background: '#fbfaf6', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
          {logo ? <img src={`${API_ORIGIN}${logo}`} alt="Дүүргийн лого" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : <span style={{ fontSize: 11, color: '#9aa39d', textAlign: 'center' }}>Лого<br />байхгүй</span>}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <button onClick={() => fileRef.current?.click()} disabled={busy} style={btnPrimary}>{logo ? 'Лого солих' : 'Лого оруулах'}</button>
          {logo && <button onClick={remove} disabled={busy} style={{ ...btnPrimary, background: '#fff', color: '#dc2626', border: '1px solid #fecaca' }}>Устгах</button>}
          <input ref={fileRef} type="file" accept="image/*" hidden onChange={e => upload(e.target.files?.[0])} />
          <span style={{ fontSize: 11.5, color: '#8a978f' }}>PNG (ил тод дэвсгэр) зөвлөнө · ≤512px болгож хадгална</span>
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        <div><label style={{ display: 'block', fontSize: 12.5, color: '#5f6f66', fontWeight: 600, marginBottom: 3 }}>Дүүрэг (богино нэр)</label><input value={district} onChange={e => setDistrict(e.target.value)} style={inputStyle} placeholder="БЗД" /></div>
        <div><label style={{ display: 'block', fontSize: 12.5, color: '#5f6f66', fontWeight: 600, marginBottom: 3 }}>Хороо</label><input value={khoroo} onChange={e => setKhoroo(e.target.value)} style={inputStyle} placeholder="16-р хороо" /></div>
      </div>
      <button onClick={save} disabled={busy} style={{ ...btnPrimary, marginTop: 12 }}>Хадгалах</button>
    </div>
  );
}


/** Домофон / хаалганы системийн интеграц — төлбөрөө N+ сар төлөөгүй тоотуудын жагсаалтыг API түлхүүрээр өгнө. */
function IntercomCard({ card, cardTitle, inputStyle, btnPrimary }: { card: any; cardTitle: any; inputStyle: any; btnPrimary: any }) {
  const [st, setSt] = useState<any>(null);
  const [newKey, setNewKey] = useState('');
  const [mm, setMm] = useState('2');
  const [prev, setPrev] = useState<any>(null);
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState('');
  const load = () => api.get<any>('/admin/integrations/intercom').then(d => { setSt(d); setMm(String(d.min_months || 2)); }).catch(() => {});
  const loadPrev = () => api.get<any>('/admin/integrations/intercom/preview').then(setPrev).catch(() => setPrev(null));
  useEffect(() => { load(); loadPrev(); }, []);
  const gen = async () => {
    if (st?.enabled && !window.confirm('Шинэ түлхүүр үүсгэвэл хуучин түлхүүр тэр дороо хүчингүй болно. Домофоны системд шинийг оруулах шаардлагатай. Үргэлжлүүлэх үү?')) return;
    setBusy('key'); try { const r: any = await api.post('/admin/integrations/intercom/key', {}); setNewKey(r.key); setSt(r); setMsg('Түлхүүр үүслээ — одоо л бүтнээр харагдана, хуулж авна уу'); } catch { setMsg('Алдаа'); } finally { setBusy(''); }
  };
  const off = async () => { if (!window.confirm('Интеграцийг унтраах уу? Домофоны систем жагсаалт авч чадахгүй болно.')) return; try { setSt(await api.delete('/admin/integrations/intercom/key')); setNewKey(''); setMsg('Унтраалаа'); } catch { setMsg('Алдаа'); } };
  const saveMm = async () => { setBusy('mm'); try { setSt(await api.put('/admin/integrations/intercom', { min_months: parseInt(mm) || 2 })); loadPrev(); setMsg('Хадгалагдлаа'); } catch { setMsg('Алдаа'); } finally { setBusy(''); } };
  const copy = (t: string) => { navigator.clipboard?.writeText(t); setMsg('Хуулагдлаа'); setTimeout(() => setMsg(''), 2000); };
  const sample = `curl -H "X-Api-Key: ${newKey || 'ic_…'}" "${st?.endpoint_debtors || ''}"`;
  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <div style={card}>
        <h3 style={cardTitle}>Домофон / хаалганы системийн интеграц</h3>
        <p style={{ margin: '0 0 12px', fontSize: 13, color: '#5f6f66' }}>
          СӨХ-ийн төлбөрөө <b>{st?.min_months ?? 2} ба түүнээс дээш сар</b> төлөөгүй тоотуудын жагсаалтыг домофоны (хаалганы) систем энэ API-аас авна.
          Үлдэгдлийн эх сурвалж Орон сууц хуудастай ижил: {st?.linked_bank ? 'Төрийн банкны (eBill) төлөгдөөгүй нэхэмжлэхийн сарууд' : 'Төлбөр хуудасны тэмдэглэгээ'}. Граж орохгүй; тоотыг Орон сууц → Засах → «Домофоны хязгаарлалтаас чөлөөлөх»-өөр түр чөлөөлнө.
        </p>
        {msg && <div style={{ background: '#f0fdf4', color: '#166534', padding: '8px 12px', borderRadius: 8, fontSize: 13, marginBottom: 10 }}>{msg}</div>}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 10, alignItems: 'end', maxWidth: 420 }}>
          <div><label style={{ display: 'block', fontSize: 12.5, color: '#5f6f66', fontWeight: 600, marginBottom: 4 }}>Хэдэн сараас дээш төлөөгүй бол хаах</label><input type="number" min={1} max={36} value={mm} onChange={e => setMm(e.target.value)} style={inputStyle} /></div>
          <button onClick={saveMm} disabled={busy === 'mm'} style={btnPrimary}>Хадгалах</button>
        </div>
        <div style={{ marginTop: 16, display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          <span style={{ fontSize: 13.5 }}>Төлөв: {st?.enabled ? <b style={{ color: '#16a34a' }}>идэвхтэй · түлхүүр {st.key_masked}</b> : <b style={{ color: '#b3412f' }}>идэвхгүй (түлхүүр үүсгээгүй)</b>}</span>
          <button onClick={gen} disabled={busy === 'key'} style={btnPrimary}>{st?.enabled ? 'Түлхүүр солих' : 'API түлхүүр үүсгэх'}</button>
          {st?.enabled && <button onClick={off} style={{ background: '#fee2e2', color: '#b91c1c', border: 'none', padding: '8px 16px', borderRadius: 10, cursor: 'pointer', fontSize: 14 }}>Унтраах</button>}
        </div>
        {newKey && (
          <div style={{ marginTop: 12, background: '#fff7ed', border: '1px solid #fdba74', borderRadius: 10, padding: 12 }}>
            <div style={{ fontSize: 12.5, color: '#9a3412', fontWeight: 600, marginBottom: 4 }}>Шинэ түлхүүр — зөвхөн одоо харагдана, домофоны нийлүүлэгчид аюулгүй сувгаар өгнө үү:</div>
            <code style={{ display: 'block', fontSize: 13, wordBreak: 'break-all', background: '#fff', padding: 8, borderRadius: 6 }}>{newKey}</code>
            <button onClick={() => copy(newKey)} style={{ marginTop: 6, background: '#e8e5dc', border: 'none', padding: '6px 12px', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>Хуулах</button>
          </div>
        )}
      </div>
      <div style={card}>
        <h3 style={cardTitle}>Нийлүүлэгчид өгөх мэдээлэл</h3>
        <div style={{ fontSize: 13.5, lineHeight: 1.7 }}>
          <div><b>Өртэй тоотууд:</b> <code>GET {st?.endpoint_debtors}</code> <button onClick={() => copy(st?.endpoint_debtors || '')} style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: '#236844', fontSize: 12.5 }}>хуулах</button></div>
          <div><b>Бүх тоот (blocked: true/false):</b> <code>GET {st?.endpoint_units}</code></div>
          <div><b>Header:</b> <code>X-Api-Key: &lt;түлхүүр&gt;</code> · <b>Нэмэлт:</b> <code>?min_months=3</code>, <code>?building=49А</code></div>
          <div><b>Кэш:</b> 60 сек; <code>ETag</code>/<code>If-None-Match</code> → өөрчлөлтгүй бол <code>304</code>. Минутад 120 хүсэлт. Хэдэн секунд тутам дуудсан ч ачаалалгүй.</div>
          <pre style={{ background: '#1c2b22', color: '#e8f0ea', padding: 12, borderRadius: 10, fontSize: 12, overflow: 'auto', marginTop: 8 }}>{sample + `

{
  "tenant": "Гарден 16 СӨХ", "generated_at": "2026-10-21T08:00:00+00:00",
  "min_months": 2, "total_units": 418, "blocked_count": 57,
  "debtors": [
    { "building": "49А", "unit_number": "45", "label": "49А байр, 45 тоот",
      "unpaid_months": 3, "months": ["2026-8", "2026-9", "2026-10"],
      "balance": 135000, "blocked": true, "exempt": false, "source": "bank" }
  ]
}`}</pre>
        </div>
      </div>
      <div style={card}>
        <h3 style={cardTitle}>Одоогийн жагсаалт {prev ? `— ${prev.blocked_count} / ${prev.total_units} тоот хаагдана (${prev.min_months}+ сар)` : ''}</h3>
        {!prev ? <p style={{ color: '#8a978f', fontSize: 13 }}>…</p> : prev.debtors.length === 0 ? <p style={{ color: '#8a978f', fontSize: 13 }}>Хаагдах тоот алга.</p> : (
          <div style={{ maxHeight: 320, overflow: 'auto', fontSize: 13.5 }}>
            {prev.debtors.map((d: any) => <div key={d.label} style={{ display: 'flex', gap: 10, padding: '6px 0', borderBottom: '1px dashed #e8e5dc' }}><span style={{ flex: 1, fontWeight: 600 }}>{d.label}</span><span style={{ color: '#b3412f' }}>{d.unpaid_months} сар</span><span style={{ color: '#5f6f66', fontVariantNumeric: 'tabular-nums', minWidth: 100, textAlign: 'right' }}>{(d.balance || 0).toLocaleString('en-US').replace(/,/g, ' ')} ₮</span></div>)}
          </div>
        )}
        {prev && prev.exempt?.length > 0 && <p style={{ fontSize: 12.5, color: '#5f6f66', marginTop: 8 }}>Чөлөөлсөн: {prev.exempt.map((u: any) => u.label).join(', ')}</p>}
      </div>
    </div>
  );
}
